<main class="requests" style="background: #fff;">
  <span (click)="goBack()" class="requests__back-arrow">
    <svg width="17" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.194 5.872H3.907l3.454-4.15A.953.953 0 1 0 5.896.505l-4.759 5.71c-.032.046-.06.094-.085.143 0 .048-.048.076-.067.124a.952.952 0 0 0-.067.343c.001.117.024.233.067.342 0 .048.048.076.067.124.025.05.053.097.085.143l4.759 5.71a.952.952 0 0 0 1.342.124.951.951 0 0 0 .123-1.342l-3.454-4.15h11.287a.952.952 0 0 0 0-1.903Z"
            fill="#2C6DA9" />
    </svg>
  </span>
  <div class="dashboard-header">
    <section class="sub-header">
      <h1>My Requests ({{getActiveRequests().length}})</h1>
      <p class="subtitle">Here you can check the details of your requests and how many exclusive offers each of them have received.</p>
    </section>
  </div>
  <section class="main-section">
    <section class="left-section">
      <div class="grid-container jc-c">
        <div class="grid-item w-100" *ngFor="let request of getActiveRequests();let i = index">
          <app-single-request [selectedRequest]="request" [requestId]="i+1" [extrasVisible]="true" (removeButtonClicked)="removeRequest($event)"></app-single-request>
        </div>
      </div>
    </section>
  </section>

  <div class="requests__button-container flex jc-c">
    <a (click)="newRequest()" class="requests__button requests__button--pink">
      Create New Request
    </a>
  </div>

</main>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white;">Loading your requests...</p>
</ngx-spinner>